import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { icon, latLng, marker, tileLayer } from 'leaflet';
import * as L from 'leaflet';
import { DataService } from '../../services/data.service';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import 'leaflet.markercluster';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from "../../app.config";
import { TicketImagesModalComponent } from '../modals/ticket-images/ticket-images-modal.component';
import { StreetViewService } from '../../services/street-view.service';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import 'leaflet.gridlayer.googlemutant';
import { concat, Observable, of, Subject } from 'rxjs';
import _ from "lodash";
import { GeocodingService } from 'src/app/services/geocoding.service';
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';

@Component({
  selector: 'app-map-report',
  templateUrl: './map-report.component.html',
  styleUrls: ['./map-report.component.scss']
})
export class MapReportComponent implements OnInit {

  shortPopupShown: boolean = false;
  morePopupShow: boolean = false;

  leafletOptions: any;

  images: Array<string>;

  private map: L.Map;
  markerCluster;

  reportStatuses = [
    {
      key: 'all',
      value: 'All'
    },
    {
      key: 'completed',
      value: 'Resolved'
    },
    {
      key: 'reported',
      value: 'Reported'
    },
    {
      key: 'rejected',
      value: 'Rejected'
    },
    {
      key: 'processing',
      value: 'In Progress'
    }];
  flattenReport: any[] = [];

  public selectedReport = {
    image: [],
    id: null,
    date: null,
    mode: null,
    category: null,
    description: null,
    solution: null,
  };

  tiles: any[] = [];
  currentTileIdx: number = 1;

  address$: Observable<any[]>;
  addressLoading: boolean = false;
  addressInput$ = new Subject<string>();

  public role = 'user';

  constructor(
    private cd: ChangeDetectorRef,
    private service: DataService,
    private config: AppConfig,
    private modalService: NgbModal,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private gsv: StreetViewService, // DO NOT REMOVE!
    private geocodingService: GeocodingService,
  ) {
  }

  ngOnInit() {
    const project = JSON.parse(localStorage.getItem('project_id'));

    let e = this.activatedRoute;
    while (e.snapshot.url.length) {
      if (e.snapshot.url.map(e => e.path).indexOf('management') > -1) {
        this.role = 'management';
      }
      else {
        this.role = 'user';
      }
      e = e.parent;
    }

    this.userService.getUserInfo().subscribe(user => this.addHomeMarker());

    let getReportsSub: Observable<any>;
    if (this.role == 'user') {
      getReportsSub = this.service.getReports(project.projectID.id);
    }
    else if (this.role == 'management') {
      getReportsSub = this.service.getAcceptedReport(project.projectID.id);
    }

    getReportsSub
      .pipe(
        map(r => r.map(it => {
          return {
            id: it.entityID.id2,
            projectId: it.entityID.id1.id,
            date: it.timeStamp,
            mode: it.genericAttributes.attributes.transportMode ? it.genericAttributes.attributes.transportMode[0] : "",
            category: it.genericAttributes.attributes.category ? it.genericAttributes.attributes.category[0] : "",
            status: it.genericAttributes.attributes.status ? it.genericAttributes.attributes.status[0] : "",
            source: it.genericAttributes.attributes.source_device ? it.genericAttributes.attributes.source_device[0] : "",
            solution: it.genericAttributes.attributes.solution ? it.genericAttributes.attributes.solution[0] : "",
            description: it.genericAttributes.attributes.description ? it.genericAttributes.attributes.description[0] : "",
            geometry: {
              lat: it.genericAttributes.attributes.geometry[0].coordinates[0],
              lon: it.genericAttributes.attributes.geometry[0].coordinates[1]
            },
            closure: it.genericAttributes.attributes.closure ? it.genericAttributes.attributes.closure[0] : "",
            image: this.mapImg(it.genericAttributes.attributes.image)
          }
        }))
      )
      .subscribe(response => {
        response.forEach(i => {
          const key = i.status.toLowerCase();
          let marker;
          if (i.status === 'COMPLETED') {
            marker = this.markerCompleted(i.geometry.lon, i.geometry.lat, i)
            this.markerCluster.addLayer(marker);
            tagMap[key].push(marker);
          } else if (i.status === 'REPORTED') {
            marker = this.markerReported(i.geometry.lon, i.geometry.lat, i);
            this.markerCluster.addLayer(marker);
            tagMap[key].push(marker);
          }
          else if (i.status === "REJECTED") {
            marker = this.markerAttention(i.geometry.lon, i.geometry.lat, i);
            this.markerCluster.addLayer(marker);
            tagMap[key].push(marker);
          }
          else if (i.status === "PROCESSING") {
            marker = this.markerProcessing(i.geometry.lon, i.geometry.lat, i);
            this.markerCluster.addLayer(marker);
            tagMap[key].push(marker);
          }
        });
      });
    let tileLayerOptions = {
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.tiles = [
      // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions),
      // @ts-ignore
      L.gridLayer.googleMutant({ type: 'satellite' }),
      this.config.getTileLayer()
    ];

    let pos;
    try {
      const center = _.cloneDeep(this.userService.project.project.projectData.center);
      pos = center ? latLng(center.coordinates.reverse()) : latLng(50.848656786354994, 4.349341392517091);
    } catch {
      pos = latLng(50.848656786354994, 4.349341392517091);
    }

    this.leafletOptions = {
      layers: [
        this.tiles[1]
      ],
      zoom: 14,
      center: pos
    };

    this.map = L.map('map', this.leafletOptions);

    // @ts-ignore
    this.markerCluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      iconCreateFunction: this.clusterIcon,
      // disableClusteringAtZoom: 18
    });
    this.map.addLayer(this.markerCluster);

    let tagMap = {};

    this.reportStatuses.forEach(e => {
      let value = false;
      let item = {
        value: value,
        key: e.key,
        target: this.markerCluster,
        entities: []
      };
      tagMap[e.key] = item.entities;
      this.flattenReport.push(item);
    })

    this.images = [
      'assets/img/pic.png',
      'assets/img/pic.png',
      'assets/img/pic.png'
    ]

    this.initTypeahead();
  }

  initTypeahead() {
    const project_location = localStorage.getItem('project_location');
    this.address$ = concat(
      of([]),
      this.addressInput$.pipe(
        distinctUntilChanged(),
        tap(() => this.addressLoading = true),
        switchMap(term => {
          if (term) {
            console.log(this.map.getCenter());
            let latlng;
            if (!project_location) { latlng = this.map.getCenter(); }
            else {
              const locations = project_location.split(',');
              var latitude = parseFloat(locations[1]),
                longitude = parseFloat(locations[0]);
              latlng = L.latLng(latitude, longitude);
            }
            return this.geocodingService.addressAutocomplete(term, latlng.lat, latlng.lng).pipe(
              catchError(() => of([])),
              map(result => {
                if (result.features) return result.features.map(r => Object.assign(r.properties, r.geometry));
                else return [];
              }),
              tap(() => this.addressLoading = false)
            );
          }
          this.addressLoading = false;
          // return of([]).pipe(
          //   map(() => this.addressLoading = false)
          // );
        })
      )
    )
  }

  findPos(latlng) {
    this.map.panTo({ lng: latlng.lon ? latlng.lon : latlng.lng, lat: latlng.lat });
    this.map.setZoom(18);
  }

  onInputAddress(event) {
    console.log('input', event);
    if (event.coordinates) {
      const latlng = L.latLng(event.coordinates[1], event.coordinates[0]);
      this.findPos(latlng);
    }
    else if (event.name) {
      this.geocodingService.findPosition(event.name).subscribe(response => {
        if (response && response.lat) this.findPos(response);
      }, err => {
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The location of this address could not be determined. Please enter a new address.';
      });
    }
  }

  markerReported(lat, lng, report) {
    return this.marker(lat, lng, 'assets/img/mark_reported.png', report);
  }

  markerCompleted(lat, lng, report) {
    return this.marker(lat, lng, 'assets/img/mark_completed.png', report);
  }

  markerRejected(lat, lng, report) {
    return this.marker(lat, lng, 'assets/img/mark_completed.png', report);
  }

  markerProcessing(lat, lng, report) {
    return this.marker(lat, lng, 'assets/img/marker_processing_32.png', report);
  }

  markerAttention(lat, lng, report) {
    return this.marker(lat, lng, 'assets/img/mark_attention.png', report);
  }

  markerNeutral(lat, lng, report) {
    return this.marker(lat, lng, 'assets/img/mark_neutral.png', report);
  }

  marker(lat, lng, iconpic, report) {
    return marker([lat, lng], {
      status: report.status,
      icon: icon({
        iconSize: [47, 57],
        iconUrl: iconpic,
        iconAnchor: [24, 57]
      })
    } as L.MarkerOptions).on('click', () => {
      this.shortPopupShown = false;
      this.morePopupShow = false;
      this.shortPopupShown = true;
      this.selectedReport = report;
      this.cd.detectChanges();
    });
  }

  toggleMapType() {
    try {
      this.tiles[this.currentTileIdx].removeFrom(this.map);
    } catch { }
    // this.currentTileIdx = this.currentTileIdx == 2 ? 0 : this.currentTileIdx + 1;
    this.currentTileIdx = this.currentTileIdx == 1 ? 0 : this.currentTileIdx + 1;
    this.tiles[this.currentTileIdx].addTo(this.map);
  }

  showMorePopup() {
    if (this.role === 'user') {
      this.shortPopupShown = false;
      this.morePopupShow = true;
    }
    else if (this.role === 'management') {
      if (this.selectedReport['closure'] == 'ACCEPTED') {
        this.router.navigate(['management', 'report', 'accepted', this.selectedReport['projectId'], this.selectedReport['id']]);
      } else if (this.selectedReport['closure'] == 'NEW') {
        this.router.navigate(['management', 'report', 'view', this.selectedReport['projectId'], this.selectedReport['id']]);
      } else if (this.selectedReport['closure'] == 'REJECTED') {
        this.router.navigate(['management', 'report', 'rejected', this.selectedReport['projectId'], this.selectedReport['id']]);
      }
    }
  }

  closePopup() {
    this.shortPopupShown = false;
    this.morePopupShow = false;
  }

  private mapImg(imgs) {
    if (imgs) {
      return imgs.map(s => `${this.config.getHost()}/api2/public/image?image_id=${s.id}&dimension=250`)
    } else {
      return ['assets/img/no_image_available.png']
    }
  }

  clusterIcon(cluster) {
    const markers = cluster.getAllChildMarkers();

    let types = [];

    console.log(markers);

    markers.forEach(m => {
      let attr = m.options['status'];
      switch (attr) {
        case 'REPORTED':
          types[0] = 'r';
          break;
        case 'COMPLETED':
          types[1] = 'g';
          break;
        case 'PROCESSING':
          types[2] = 'b';
      }
    });

    let colorClass = types.join('');
    return L.divIcon({ html: markers.length, className: `cluster cluster-${colorClass}`, iconSize: L.point(47, 47) });
  }



  openAttachModal(id) {
    const options: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      windowClass: 'attachImageModal'
    };

    const dlg = this.modalService.open(TicketImagesModalComponent, options);
    dlg.componentInstance.images = this.selectedReport.image;
    dlg.componentInstance.selectedID = id;
  }

  addHomeMarker() {
    let userLocation = this.userService.user.attributes.location[0].coordinates;
    var homeMarker = L.marker(new L.LatLng(userLocation[1], userLocation[0]), {
      icon: L.icon({ iconUrl: 'assets/marker/home.png', iconSize: [57, 67], iconAnchor: [27, 66] }),
      draggable: true
    });

    homeMarker.bindTooltip(`${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`);

    this.map.addLayer(homeMarker);
  }

  onChange(value) {
    this.flattenReport.forEach(l => {
      l.value = false;
      if (value === 'all') {
        l.value = true;
      }

    })

    this.updateByChosenStatus(value);
  }

  updateByChosenStatus(value) {
    let chosenReport = this.flattenReport.filter((e) => e.key == value);
    if (chosenReport.length || value === 'all') {
      if (chosenReport) chosenReport[0].value = true;

      this.flattenReport.forEach(l => {
        l.entities.forEach(e => {
          if (l.target) l.target.removeLayer(e);
          else this.map.removeLayer(e);
          if (l.value) {
            if (l.target) l.target.addLayer(e);
            else this.map.addLayer(e);
          }
        })
      });
    }
  }
}
